// extracted by mini-css-extract-plugin
export default {"themeOrangeColor":"#d1990e","themeOrange2Color":"#ffa305","themeGreyColor":"#303030","themeGrey2Color":"#545454"};